import React from 'react'
import Card from 'react-bootstrap/Card'
import Image from '@components/Image'
import { Item } from 'types'
// import { getTextShort } from '@helpers/helper.rendering'
// @ts-ignore 
import Avatar from './assets/avatar_default.webp'

interface PropsType {
    skeleton?: boolean,
    testimony?: Item
}

const Testimony = (props: PropsType) => {

    const {testimony, skeleton} = props;

    return (
        <div id="testimony-wrapper" className={"testimony d-flex" + (skeleton ? " skeleton-card" : "")}>
            <Card className="testimony-card">
                <Card.Body className={"p-4" + (skeleton ? " skeleton-body" : "")}>
                    <div className="d-flex flex-column align-items-center top-testimony-content">
                        { (testimony && !skeleton) ? 
                            <Image objectFit="cover"
                                className="avatar-img"
                                alt={testimony?.title!!}
                                image={testimony?.image_gatsby!!} /> : null }
                        { (!testimony && skeleton) ? 
                            <img src={Avatar} alt="Avatar" className="avatar-img"/>
                        : null }
                    </div>
                    <Card.Text className={"mt-4 text-start" + (skeleton ? " skeleton-text" : "")}>
                        {/* { !skeleton ? (testimony?.paragraph ? `"${getTextShort(testimony?.paragraph, 180)}"` : null) : null } */}
                        { !skeleton ? (testimony?.paragraph ? `"${testimony?.paragraph}"` : null) : null }
                    </Card.Text>
                    <Card.Title as="h4" className={"mt-4 text-start" + (skeleton ? " skeleton-title" : "")}>
                        { !skeleton ? (testimony?.title ? testimony?.title : null) : null }
                    </Card.Title>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Testimony